import { AgTechIndex } from "@agtech/core/utilities/AgTechUtilities"
import { ContactNote } from "./notes/ContactNoteData"

/// Contact Entities

export type AgTechContact = {
    id: number,
    ranchName: string,
    firstName: string,
    lastName: string,
    phoneNumber: string,
    emailAddress: string,
    address: string,
    zip: string,
    city: string,
    stateAbbreviation: string,
    operationId: number
}

export const DefaultAgTechContact: AgTechContact = {
    id: 0,
    ranchName: '',
    firstName: '',
    lastName: '',
    phoneNumber: '',
    emailAddress: '',
    address: '',
    zip: '',
    city: '',
    stateAbbreviation: '',
    operationId: 0
}

export type ContactMetadata = {
    notes: AgTechIndex<ContactNote>
}

export type ContactDetails = {
    contact: AgTechContact
} & ContactMetadata;

/// Helpers

export const getContactFullName = (contact?: AgTechContact) => contact ? contact.firstName + ' ' + contact.lastName : 'No Name Available';

export const getContactAddress = (contact?: AgTechContact) => contact ? `${contact.address}, ${contact.city}, ${contact.stateAbbreviation} ${contact.zip}` : '-';